module.exports = __webpack_public_path__ + "static/media/chicken6.701cb94b.jpg";